import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { Meeting } from '/@/modules/meeting/models/Meeting';

export class MeetingCollection extends ModelCollection<Meeting> {
  constructor(items: Meeting[] | MeetingCollection | null = null) {
    super(items, Meeting);
  }

  static mapModel(items: Meeting[] | MeetingCollection | null = null): MeetingCollection {
    return new this(items);
  }

  get intakeMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isIntakeType);
  }

  get basicSupportMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isBasicSupportType);
  }

  get notarizationMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isNotarizationType);
  }

  get willNotarizationMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isWillNotarizationType);
  }

  get guidanceMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isGuidanceType);
  }

  get protectionMandateNotarizationMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isProtectionMandateNotarizationType);
  }

  get willReviewMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isWillReviewType);
  }

  get annualReviewMeeting(): Meeting | undefined {
    return this.items?.find((meeting: Meeting) => meeting.isAnnualReviewType);
  }
}
